import React from "react";
import { useTheme } from "../contexts/ThemeContext";

const Logo = ({ size = "medium" }) => {
  const { isDarkMode } = useTheme();
  const logoSrc = isDarkMode ? "/images/darklogo.png" : "/images/lightlogo.png";

  const sizeClasses = {
    small: "h-10",
    medium: "h-16",
    large: "h-20"
  };

  return (
    <img
      src={logoSrc}
      alt="AZBGA Logo"
      className={`${sizeClasses[size]} w-auto transition-all duration-300 ease-in-out`}
    />
  );
};

export default Logo;
